class PageContent {
    private element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
        this.init();
    }

    private init(): void {
        const tableOfContent = this.element.querySelector(".toc-column") as HTMLElement;
        const toc = tableOfContent.querySelector(".content") as HTMLElement;
        const textContent = this.element.querySelector(".text-column") as HTMLElement;
        const headings = Array.from(this.element.querySelectorAll("h2")) as HTMLElement[];

        if (!tableOfContent || !textContent) return;

        if (headings.length === 0) {
            tableOfContent.remove();
            return;
        }

        headings.forEach((heading, index) => {
            const sectionId = `section-${index}`;
            heading.id = sectionId;

            const tocItem = `<a href="#${sectionId}" class="content-item"><span class="display-xs">${heading.textContent}</span></a>`;

            toc.innerHTML += tocItem;
        });
    };
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.page-content').forEach(element => {
        new PageContent(element as HTMLElement);
    });
});